import { FC } from 'react';
import HTMLReactParser from 'html-react-parser';
import { PageContainer } from '@edikk-edikk/country-layout-black';
import HomeContentCss from '#home/asssets/home-content.module.scss';
import { useHomeContext } from '#home/hooks';

const SeoText: FC = () => {
  const { seo } = useHomeContext();

  if (!seo.text) {
    return null;
  }

  return (
    <PageContainer additionalClassName={HomeContentCss.homeContent__seoTextHolder}>
      {HTMLReactParser(seo.text)}
    </PageContainer>
  );
};

export { SeoText };
